import React, {useEffect, useState} from 'react';
import axios from "axios";
import {
    Checkbox,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel, ListItemText,
    MenuItem,
    Select,
    Stack,
    TextField, Typography
} from "@mui/material";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText, IconButton, withStyles,
} from "@material-ui/core";

import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import MuiTableCell from "@material-ui/core/TableCell";
import styles from "../../AuctionSettingsForm/AuctionSettingsForm.module.css";
import {    Editor, EditorChangeEvent,
    EditorTools,
    EditorUtils,
    ProseMirror} from "@progress/kendo-react-editor";
import {ChevronLeft, ChevronRight} from "@material-ui/icons";
import DateTimeInput from "../../../components/common/inputs/DateTimeInput";
import HookForm from "../../../components/common/HookForm";
import {useForm} from "react-hook-form";

const EmailReview = ({eventid, massemailid, selectedRow}) => {
    const formMethods = useForm<FormData>()
    const { reset, watch, setValue } = formMethods

    const [reviewData, setReviewData] = useState({showpreviewbutton: true, showsendbutton: true, showcancelbutton: false, sendemailcount: 0, sections: [], previewlist: []});
    const [previewData, setPreviewData] = useState({emailbody: '', fromemail: '', fromname: '', key: '', locked: false, subject: '', toemail: '', toname: ''});
    const [previewDataIndex, setPreviewDataIndex] = useState(0)
    const [dialogMsg, setDialogMsg] = React.useState("");
    const [isEmailPreviewModalOpen, setIsEmailPreviewModalOpen] = useState(false);
    const [isEmailError, setIsEmailError] = useState(false);
    const [email, setEmail] = useState('');

    const [isEmailSendingModalOpen, setIsEmailSendingModalOpen] = useState(false);

    const { Bold, Italic, Underline, ViewHtml } = EditorTools;

    const handleEmailSendingCloseModal = () => {
        setIsEmailSendingModalOpen(false);
    };

    const handleEmailPreviewCloseModal = () => {
        setIsEmailPreviewModalOpen(false);
    };

    const TableCell = withStyles({
        root: {
            border: "none",
            // border: "3px dashed #eeeeee;"
        }
    })(MuiTableCell);

    useEffect(() => {
        const body = {'eventid': eventid, 'massemailid': massemailid}

        const fetchData = async () => {
            const { data } = await axios.post('/evtmassemailreview', body)
            const parsedData = JSON.parse(data.jsonString)
            setReviewData(parsedData)
            console.log(parsedData)
            setPreviewData(parsedData?.previewlist[previewDataIndex])
        }

        fetchData()
    }, [])


    const save = async () => {
        const body = {
            "eventid": eventid,
            "massemailid": massemailid
        }

        const { data } = await axios.post('/evtmassemailsend', body)
        const parsedData = JSON.parse(data.jsonString)
        if (parsedData.status === 'success') {
            setDialogMsg('Email(s) sent successfully.')
            setIsEmailSendingModalOpen(false);
        }
        else {
            setIsEmailSendingModalOpen(false);
        }
    }

    const closeDialog = () => {
        setDialogMsg("")
    }

    const clickActionBUtton = (dInfo) => {
        if (dInfo.sectiontype === 'PREVIEW') {
            setIsEmailPreviewModalOpen(true)
        }
        else if (dInfo.sectiontype === 'SEND') {
            setIsEmailSendingModalOpen(true)
        }
    }

    const getSections = (dataPreview) => {

        return dataPreview?.sections?.filter(item => item.sectionshow == true).map(dInfo => {
            var color = '#5732db;'
            if (dInfo.sectiontype == 'CANCEL') {
                color = 'red'
            }

             return (
                 <>
                     <Stack spacing={2}>
                         <div style={{paddingTop: '20px', paddingLeft: '20px', float: 'right', color: 'black', fontWeight: 'bold'  }}>{dInfo.sectiontitle}</div>
                         {dInfo?.sectiondata?.map((item) => (
                             <>
                                <div style={{paddingTop: '5px', paddingLeft: '30px', float: 'right', color: 'black'  }}>{item.label} {item.value}</div>
                             </>
                         ))}
                     </Stack>
                     <Stack spacing={2}>
                         {/*<TableCell style={{width: '40%'}} align="center">*/}
                         <div style={{display: 'flex', alignItems: 'left', justifyContent: 'left', paddingLeft: '30px', paddingTop: '20px', paddingBottom: '20px'}}>
                             <Button
                                 variant="contained"
                                 color="primary"
                                 style={{width: '200px', backgroundColor: color}}
                                 onClick={() => clickActionBUtton(dInfo)}
                             >
                                 {dInfo.sectiontype}
                             </Button>
                         </div>
                         {/*</TableCell>*/}
                     </Stack>
                 </>
            )
        })
    }

    const onNext = () => {
        // const previewLength = reviewData?.previewlist?.length
        if (reviewData?.previewlist?.length > previewDataIndex) {
            setPreviewDataIndex(previewDataIndex+1)
            setPreviewData(reviewData?.previewlist[previewDataIndex+1])
        }
    }

    const onPrevious = () => {
        if (previewDataIndex != 0) {
            setPreviewDataIndex(previewDataIndex-1)
            setPreviewData(reviewData?.previewlist[previewDataIndex-1])
        }
    }

    const sendEmail = async () => {
        const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
        const testResults = emailRegex.test(email)
        console.log(testResults)
        setIsEmailError(testResults == false)

        if (testResults) {
            const emailDataFromList = reviewData?.previewlist[previewDataIndex]
            console.log(emailDataFromList)

            var body = {
                "eventid": eventid,
                "massemailid": massemailid,
                "testemail": email,
                "key": emailDataFromList.key
            }
            const { data } = await axios.post('/evtmassemailtestemail', body)
            const parsedData = JSON.parse(data.jsonString)
            console.log(parsedData)
        }
    }

    const validateEmail = (e) => {
        setEmail(e.target.value)
        const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
        setIsEmailError(emailRegex.test(e.target.value) == false)
    }

    const onSubmitScheduleSend = (formData: FormData) => {
        console.log(formData)
    }

    return (
        <>
            <>
                <Dialog maxWidth="xl" fullWidth={true} open={isEmailSendingModalOpen}  onClose={handleEmailSendingCloseModal} className={styles.dialog}>
                    {/*<DialogTitle id="form-dialog-title">Preview and Send Test Emails</DialogTitle>*/}
                    <HookForm
                        methods={formMethods}
                        onSubmit={onSubmitScheduleSend}
                        // className={styles.form}
                        formProps={{ id: 'EmailReview-form' }}>

                        <DialogTitle style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: 'center',
                            justifySelf: 'center'}}>
                            <Stack direction="row" spacing={2}>
                                <Typography variant="h5" align="left">Send Your Email</Typography>
                            </Stack>
                        </DialogTitle>
                        <DialogContent>
                            <div style={{ padding: 20 }}>
                                <Grid container spacing={2} >
                                    <Grid item xs={12}>
                                        <div style={{float: 'left', color: 'black' }}>You are about to schedule the sending of {reviewData?.sendemailcount} emails.</div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{float: 'left', color: 'black' }}>While waiting to send this email, it's body and recipients will be locked from editing. No new recipients will be added to this email, and changes made to the guest/ticket records will not be reflected in these emails. If you need to make a change while your email is already scheduled, first cancel the pending email to unlock it and make any necessary changes.</div>
                                    </Grid>
                                    {/*<Grid item xs={12}>*/}
                                    {/*    <DateTimeInput*/}
                                    {/*        name="scheduledate"*/}
                                    {/*        defaultValue={new Date().toISOString()}*/}
                                    {/*        label="Send Email Date Time"*/}
                                    {/*        // dateTimeProps={{ fullWidth: true }}*/}
                                    {/*        // textFieldProps={{ fullWidth: true }}*/}
                                    {/*    />*/}
                                    {/*</Grid>*/}
                                </Grid>
                            </div>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={handleEmailSendingCloseModal} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={save} color="primary" type="submit" variant="contained">
                                Send
                            </Button>
                        </DialogActions>
                    </HookForm>
                </Dialog>
            </>
            <>
                <Dialog maxWidth="xl" fullWidth={true} open={isEmailPreviewModalOpen}  onClose={handleEmailPreviewCloseModal} className={styles.dialog}>
                    {/*<DialogTitle id="form-dialog-title">Preview and Send Test Emails</DialogTitle>*/}
                    <DialogTitle style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        justifySelf: 'center'}}>
                        <Stack direction="row" spacing={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={previewDataIndex == 0}
                                onClick={() => onPrevious()}
                            >
                                <ChevronLeft className={styles.arrow} /> Previous Email
                            </Button>
                            <Typography variant="h4" align="center">Preview and Send Test Emails</Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={previewDataIndex == reviewData?.previewlist?.length}
                                // style={{width: '200px', backgroundColor: color}}
                                onClick={() => onNext()}
                            >
                                Next Email<ChevronRight className={styles.arrow} />
                            </Button>
                        </Stack>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{ padding: 20 }}>
                            <Grid container spacing={2} >
                                <Grid item xs={1}>
                                    <div style={{float: 'right', color: 'black', fontWeight: 'bold' }}>From Name:</div>
                                </Grid>
                                <Grid item xs={11}>
                                    <div style={{float: 'left', color: 'black' }}>{previewData?.fromname}</div>
                                </Grid>

                                <Grid item xs={1}>
                                    <div style={{float: 'right', color: 'black', fontWeight: 'bold' }}>From Email:</div>
                                </Grid>
                                <Grid item xs={11}>
                                    <div style={{float: 'left', color: 'black' }}>{previewData?.fromemail}</div>
                                </Grid>

                                <Grid item xs={1}>
                                    <div style={{float: 'right', color: 'black', fontWeight: 'bold' }}>To Email:</div>
                                </Grid>
                                <Grid item xs={11}>
                                    <div style={{float: 'left', color: 'black' }}>{previewData?.toemail}</div>
                                </Grid>

                                <Grid item xs={1}>
                                    <div style={{float: 'right', color: 'black', fontWeight: 'bold' }}>Subject:</div>
                                </Grid>
                                <Grid item xs={11}>
                                    <div style={{float: 'left', color: 'black' }}>{previewData?.subject}</div>
                                </Grid>
                                <Grid item xs={1}>
                                    {/*<div style={{ paddingTop: 20 }}>*/}
                                    <div style={{float: 'right', color: 'black', fontWeight: 'bold' }}>Email Body:</div>
                                    {/*</div>*/}
                                </Grid>
                            </Grid>


                            <Grid item xs={12}>
                                <div style={{ paddingBottom: 20 }}>
                                    <div key="email-body" dangerouslySetInnerHTML={{ __html: previewData?.emailbody}} />
                                </div>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    type={"email"}
                                    name={"sendmessagetoo"}
                                    placeholder={'example@auctionsnap.com'}
                                    label={"Send Message To:"}
                                    // value={(e)=> { setEmail(e.target.value) }}
                                    onChange={(e) => { validateEmail(e) }}
                                    helperText={isEmailError ? 'Please enter a valid email.' : ' '}
                                    error={isEmailError} fullWidth required
                                />
                            </Grid>
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleEmailPreviewCloseModal} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={sendEmail} color="primary" disabled={isEmailError || email?.length == 0} variant="contained" className={styles.button}>
                            Send
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
            <>
                <Dialog
                    open={dialogMsg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </>
            <div style={{ padding: 20 }}>
                <Grid container spacing={2} >
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table>
                                <>
                                    {getSections(reviewData)}
                                </>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}
export default EmailReview

